"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _date = require("@/utils/date");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DateSelect',
  props: {
    value: {
      type: String,
      default: ''
    },
    startYear: {
      type: Number,
      default: 1950
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      localValue: {
        year: '',
        month: '',
        day: ''
      }
    };
  },
  computed: {
    yearOptions: function yearOptions() {
      return (0, _date.getYearOptions)(this.startYear);
    },
    dayOptions: function dayOptions() {
      return (0, _date.getDayOptions)(this.localValue);
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.localValue = (0, _date.parseDateString)(val);
      }
    }
  },
  methods: {
    pad2: _date.pad2,
    handleChange: function handleChange() {
      this.localValue = (0, _date.normalizeDateDay)(this.localValue);
      this.$emit('input', (0, _date.buildDate)(this.localValue));
      this.$emit('change', (0, _date.buildDate)(this.localValue));
    }
  }
};